<template>
  <div id="app-page-classes">
    <classes />
  </div>
</template>

<script>

import { SET_CLASSES, SET_EO_ID } from './store/mutations.types'
import Classes from './components/Classes'
import { GET_CLASSES } from './store/actions.types'
export default {
  name: 'App',
  components: {
    classes: Classes
  },
  mounted () {
    this.$store.commit(SET_EO_ID, document.body.getAttribute('data-eo-id'))
    this.$store.dispatch(GET_CLASSES).then((res) => {
      if (res.data.response === 'success') {
        this.$store.commit(SET_CLASSES, res.data.data)
      }
    })
  }
}
</script>

<style lang="less">
</style>
